import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import QuoteInformationView from "./single";
import QuotesListView from "./list";
import useAccessLevels from "../../../../../hooks/use-access-levels";


const QuoteViews = () => {
    const operatorAccessLevels = useAccessLevels();

    return (
        <Switch>
            {
                operatorAccessLevels.packages.sales.quoteInformation &&
                <Route path={routes.customer.sales.quotes.single} exact>
                    <QuoteInformationView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.sales.quotesList &&
                <Route path={[
                    routes.sales.quotes,
                    routes.customer.sales.quotes.base,
                ]} exact>
                    <QuotesListView/>
                </Route>
            }
            <Redirect to={routes.sales.quotes.concat(routes.error.serverErrorForSection)}/>
        </Switch>
    );
};

export default QuoteViews;
